import { render } from "./DatasetCopyModal.vue?vue&type=template&id=39599b00&scoped=true"
import script from "./DatasetCopyModal.vue?vue&type=script&lang=js"
export * from "./DatasetCopyModal.vue?vue&type=script&lang=js"

import "./DatasetCopyModal.vue?vue&type=style&index=0&id=39599b00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39599b00"]])

export default __exports__